export default __webpack_public_path__ + "static/brand-moments-8e083fa615deac49d841e91393a64023.png";